
import { useContext, useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import SafeCarouel from 'components/ui/carousel';
import { useNavigate } from "react-router-dom";
import BookBtn from 'components/ui/bookbtn';
import Contact from './Contact';
import { StoreContext } from "../../layout/HomeLayout/index";
import OpeningHour from "components/home/openingHour";
import PriceList from "components/home/priceList";
import PromoPopup from "components/home/promoPopup";
import HomeText from "components/home/homeText";
import StoreMap from "components/home/storeMap";

const Home = () => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const { allmenu, store } = useContext(StoreContext);
  const [hometexts, setHometexts] = useState([]);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const homeTexts = store.images ? store.images.filter((image) => image.type == 4) : [];
    //console.log(homeTexts);
    setHometexts(homeTexts);
    let imgs = store?.images?.filter(image => image.type == 3); // get popup
    //console.log(imgs);
    if (imgs?.length > 0) {
      setPopup(imgs[0]);
    }
  }, [store]);

  return (
    <Box display='flex' sx={{
      mx: '-0.4em',
      flexWrap: 'wrap',
      fontSize: { xs: '9px', sm: '10px', md: '15px' }
    }}
    >
      <PromoPopup popup={popup} />
      <Box display='flex' width='100%' sx={{ flexDirection: 'column', pt: '1em' }}>
        <Box display='flex' sx={{ textAlign: 'center', px: '3.2em', pt: '1em', justifyContent: 'center' }}>
          <BookBtn />
        </Box>
        {/* <Box>
          <SafeCarouel store={store} />
        </Box> */}
        
        <Box sx={{ pt:'0em' }}>
          <Box width='100%' sx={{
            py: '1em',
            textAlign: 'center',
            px: '3em',
            backgroundColor: 'white'
          }}>
            <Typography variant="h1" sx={{
              fontWeight: 800,
              fontSize: '5em',
              py: 0,
              lineHeight: '1.5em',
              color: '#800020'
            }}>
              S A L O N S
            </Typography>
          </Box>
          <Box display='flex' sx={{ alignItems: 'center', justifyContent: 'space-between', py: '1em', flexWrap: 'wrap' }}>
            <Box sx={{ width: { xs: '100%', md: '50%' }, textAlign: 'center', px: '2em' }}>
              <StoreMap
                store={store}
                branch="covent"
                name="Covent Garden"
                address={store.address}
                contact={store.mobile}
                map={store.map}
              />
            </Box>
            <Box sx={{ width: { xs: '100%', md: '50%' }, textAlign: 'center', px: '2em' }}>
              <StoreMap
                store={store}
                branch="soho"
                name="Soho"
                address="24 Lichfield Street, London WC2H 9NJ"
                contact="074969 25470"
                map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.018547996392!2d-0.1311742877291623!3d51.51287571018564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604cd7ae885f1%3A0x58387115e3101848!2s24%20Litchfield%20St%2C%20London%20WC2H%209NJ!5e0!3m2!1sen!2suk!4v1747304608654!5m2!1sen!2suk"
              />
            </Box>
          </Box>
        </Box>
        {hometexts[0] && (
          <HomeText hometext={hometexts[0]} />
        )}
        {hometexts[1] && (
          <HomeText hometext={hometexts[1]} />
        )}
        <Box display='flex' sx={{ flexWrap: 'wrap', alignItems: 'center' }}>
          <OpeningHour />
        </Box>
        <Box sx={{ mt: '2em', px: '2em', textAlign: 'center' }}>
          <PriceList />
          <Box>
            <Button
              onClick={() => navigate('./price')}
              variant='contained'
              color='secondary'
              sx={{ mb: '1em', width: 'auto' }}
            >
              Discover the complate price list
            </Button>
          </Box>
        </Box>
        <Box>
          <Contact />
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
